module.exports = __webpack_public_path__ + "static/media/logo.de297f40.png";